module.exports = __webpack_public_path__ + "static/img/sence-8-map.653857d.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/sence-8-map.png
// module id = l0ib
// module chunks = 1